// getVipLevelLivestreamChatStyle.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';
import getRemoteConfigData from './getRemoteConfigData.js';
import {
  PUBLIC_BADGE_URL_PATH,
  VIP_LEVEL_1_LIVESTREAM_STYLE,
  VIP_LEVEL_2_LIVESTREAM_STYLE,
  VIP_LEVEL_3_LIVESTREAM_STYLE,
  VIP_LEVEL_4_LIVESTREAM_STYLE,
  VIP_LEVEL_5_LIVESTREAM_STYLE,
  VIP_LEVEL_6_LIVESTREAM_STYLE,
  VIP_LEVEL_7_LIVESTREAM_STYLE,
  VIP_LEVEL_8_LIVESTREAM_STYLE,
} from '../RemoteConfigKeys.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { PUBLIC } from '../resource/resourceUrlTypeConstants.js';

/**
 * Select vip level livestream chat style by level
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {number} level - select key.
 * @return {object} The selected vip level livestream chat style.
 */
const getVipLevelLivestreamChatStyle = createCachedSelector(
  (state, level) => level,
  state => getRemoteConfigData(state, VIP_LEVEL_1_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_2_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_3_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_4_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_5_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_6_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_7_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, VIP_LEVEL_8_LIVESTREAM_STYLE),
  state => getRemoteConfigData(state, PUBLIC_BADGE_URL_PATH),
  (
    level,
    vipLevel1LivestreamChat,
    vipLevel2LivestreamChat,
    vipLevel3LivestreamChat,
    vipLevel4LivestreamChat,
    vipLevel5LivestreamChat,
    vipLevel6LivestreamChat,
    vipLevel7LivestreamChat,
    vipLevel8LivestreamChat,
    publicBadgeUrlPath
  ) => {
    let result = {};
    const vipLevelLivestreamChat = {
      1: vipLevel1LivestreamChat,
      2: vipLevel2LivestreamChat,
      3: vipLevel3LivestreamChat,
      4: vipLevel4LivestreamChat,
      5: vipLevel5LivestreamChat,
      6: vipLevel6LivestreamChat,
      7: vipLevel7LivestreamChat,
      8: vipLevel8LivestreamChat,
    };

    if (Object.keys(vipLevelLivestreamChat).includes(`${level}`)) {
      const [backgroundColor, borderColor, borderImage] =
        vipLevelLivestreamChat[level];

      const borderImageName = borderImage.split(':')?.[1];
      result = {
        backgroundColor: backgroundColor.split(':')?.[1],
        borderColor: borderColor.split(':')?.[1],
        borderImage: borderImageName
          ? getResourceUrl({
              path: publicBadgeUrlPath,
              endpoint: `/${borderImageName}.svg`,
              resourceType: PUBLIC,
            }).href
          : '',
      };
    }

    return result instanceof Collection ? result.toJS() : result;
  }
)((state, level) => `${level}`);

export default getVipLevelLivestreamChatStyle;
